import { FC } from 'react';

import { Link } from 'react-router-dom';
import MandatoryField from '../MandatoryField';
import IconTooltip from '../Icon/IconTooltip';

type InputCheckboxProps = {
  id: string;
  checked: boolean;
  label: string;
  onChange: () => void;
  required?: boolean;
  lgSize?: boolean;
  disabled?: boolean;
  marginBottom?: number;
  readOnly?: boolean;
  tooltip?: string;
  href?: string;
  target?: string;
  linkLabel?: string;
  onLinkClick?: () => void;
};

const InputCheckbox: FC<InputCheckboxProps> = ({
  id,
  checked,
  label,
  onChange,
  required = false,
  disabled = false,
  marginBottom,
  readOnly = false,
  tooltip,
  href,
  target,
  linkLabel,
  onLinkClick,
}) => {
  const InputComponent = (
    <input
      type="checkbox"
      className="custom-control-input"
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
    />
  );

  return (
    <div
      className={`custom-control custom-checkbox ${
        marginBottom !== undefined ? `mb-${marginBottom}` : ''
      }`}
    >
      {InputComponent}
      {label && (
        <label className="custom-control-label" htmlFor={id}>
          {label}

          {onLinkClick && (
            <button
              type="button"
              className="btn btn-link p-0 ml-1 align-baseline"
              onClick={onLinkClick}
            >
              {linkLabel}
              <em className="icon ni ni-external-alt ml-1" />
            </button>
          )}

          {!onLinkClick && href && (
            <Link
              to={href}
              target={target}
              rel="noopener noreferrer"
              className="ml-1"
            >
              {linkLabel}
              <em className="icon ni ni-external-alt ml-1" />
            </Link>
          )}

          {required && (
            <span className="ml-1">
              <MandatoryField />
            </span>
          )}

          {tooltip && (
            <span className="d-inline-block">
              <IconTooltip
                id={`${id}-tooltip`}
                tooltip={tooltip}
                place="right"
                className="text-primary"
              />
            </span>
          )}
        </label>
      )}
    </div>
  );
};

export default InputCheckbox;
